module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "running_top_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Lord of the universe: I am a simple man, an ignorant man. Oh, how I wish I had the words to fashion beautiful prayers to praise thee! But alas, I cannot find the words. So, listen to me, O God, as I recite the alphabet. You know what I think and how I feel. Take these letters of the alphabet and you form the words to express the yearning, the love for thee, that is in my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("UNKNOWN")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a249c9cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03frontmatter01.vue
// module id = 60
// module chunks = 0